export default "__VITE_ASSET__DQucL79G__"